/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { UniteMesureDto } from '../models/unite-mesure-dto';


/**
 * Fonctions de gestion des unités de mesure
 */
@Injectable({
  providedIn: 'root',
})
export class UnitesMesureService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uniteMesureGetList
   */
  static readonly UniteMesureGetListPath = '/api/unites-mesure/list';

  /**
   * Renvoie la liste des unités de mesures.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesureGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<UniteMesureDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesureGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UniteMesureDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des unités de mesures.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesureGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureGetList(params?: {
  }): Observable<Array<UniteMesureDto>> {

    return this.uniteMesureGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UniteMesureDto>>) => r.body as Array<UniteMesureDto>)
    );
  }

  /**
   * Path part for operation uniteMesureLoadList
   */
  static readonly UniteMesureLoadListPath = '/api/unites-mesure/load-list';

  /**
   * Renvoie la liste des unités de mesures (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesureLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesureLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesureLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des unités de mesures (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesureLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesureLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.uniteMesureLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation uniteMesureGet
   */
  static readonly UniteMesureGetPath = '/api/unites-mesure/{id}';

  /**
   * Renvoie l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesureGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureGet$Response(params: {

    /**
     * Identifiant de l&#x27;unité de mesure
     */
    id: number;
  }): Observable<StrictHttpResponse<UniteMesureDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesureGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UniteMesureDto>;
      })
    );
  }

  /**
   * Renvoie l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesureGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureGet(params: {

    /**
     * Identifiant de l&#x27;unité de mesure
     */
    id: number;
  }): Observable<UniteMesureDto> {

    return this.uniteMesureGet$Response(params).pipe(
      map((r: StrictHttpResponse<UniteMesureDto>) => r.body as UniteMesureDto)
    );
  }

  /**
   * Path part for operation uniteMesurePut
   */
  static readonly UniteMesurePutPath = '/api/unites-mesure/{id}';

  /**
   * Met à jour l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesurePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesurePut$Response(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à mettre à jour
     */
    id: number;

    /**
     * Unité de mesure
     */
    body: UniteMesureDto
  }): Observable<StrictHttpResponse<UniteMesureDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesurePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UniteMesureDto>;
      })
    );
  }

  /**
   * Met à jour l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesurePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesurePut(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à mettre à jour
     */
    id: number;

    /**
     * Unité de mesure
     */
    body: UniteMesureDto
  }): Observable<UniteMesureDto> {

    return this.uniteMesurePut$Response(params).pipe(
      map((r: StrictHttpResponse<UniteMesureDto>) => r.body as UniteMesureDto)
    );
  }

  /**
   * Path part for operation uniteMesureDelete
   */
  static readonly UniteMesureDeletePath = '/api/unites-mesure/{id}';

  /**
   * Supprime l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesureDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureDelete$Response(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesureDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesureDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uniteMesureDelete(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.uniteMesureDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation uniteMesurePost
   */
  static readonly UniteMesurePostPath = '/api/unites-mesure';

  /**
   * Crée l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesurePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesurePost$Response(params: {

    /**
     * Unité de mesure
     */
    body: UniteMesureDto
  }): Observable<StrictHttpResponse<UniteMesureDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesurePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UniteMesureDto>;
      })
    );
  }

  /**
   * Crée l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesurePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesurePost(params: {

    /**
     * Unité de mesure
     */
    body: UniteMesureDto
  }): Observable<UniteMesureDto> {

    return this.uniteMesurePost$Response(params).pipe(
      map((r: StrictHttpResponse<UniteMesureDto>) => r.body as UniteMesureDto)
    );
  }

  /**
   * Path part for operation uniteMesureDesactivate
   */
  static readonly UniteMesureDesactivatePath = '/api/unites-mesure/{id}/desactivate';

  /**
   * Désactive l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uniteMesureDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesureDesactivate$Response(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: UniteMesureDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, UnitesMesureService.UniteMesureDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive l'unité de mesure spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uniteMesureDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uniteMesureDesactivate(params: {

    /**
     * Identifiant de l&#x27;unité de mesure à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: UniteMesureDto
  }): Observable<number> {

    return this.uniteMesureDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
